import React from 'react';
import { useTranslation } from 'react-i18next';

import DV from 'ts-data-validator';

export default function ProfileView({ ...props }) {
  const {
          address,
          email,
          firstName,
          lastName,
          login,
          patronymic,
          phone,
        } = props;

  const { t } = useTranslation();

  let name = t('client_notFilled');

  if (typeof firstName === 'string' || typeof lastName === 'string' || typeof patronymic === 'string') {
    name = DV.isNotEmptyString(firstName) ? `${firstName} ` : '';
    name += DV.isNotEmptyString(patronymic) ? `${patronymic} ` : '';
    name += DV.isNotEmptyString(lastName) ? lastName : '';
  }

  return (
    <section>
      <div className={'container'}>
        <div className={'view'}>
          <div className={'line'}>
            <span>{t('client_name')}:</span>
            <div>{name.trim()}</div>
          </div>
          <div className={'line'}>
            <span>E-mail:</span>
            <div>{email || t('client_notFilled')}</div>
          </div>
          <div className={'line'}>
            <span>{t('field_login')}:</span>
            <div>{login || t('client_notFilled')}</div>
          </div>
          <div className={'line'}>
            <span>{t('field_phone')}:</span>
            <div>{phone || t('client_notFilled')}</div>
          </div>
          <div className={'line'}>
            <span>{t('field_address')}:</span>
            <div>{address || t('client_notFilled')}</div>
          </div>
        </div>
      </div>
    </section>
  );
}